import ApiRouteProvider from '../route'
import axios from '@axios'

export default {
    getTranslations(locale, groups = []) {
        const normalizedGroups = Array.isArray(groups)
            ? groups.filter(Boolean)
            : [groups].filter(Boolean)
        const config = normalizedGroups.length > 0
            ? {params: {groups: normalizedGroups.join(',')}}
            : undefined

        return axios.get(ApiRouteProvider.i18n.translations(locale), config);
    },

    switchLanguage(language) {
        return axios.post(ApiRouteProvider.i18n.switchLanguage(), {'language' : language});
    },

    getLanguages() {
        return new Promise((resolve) => {
           resolve({
               data: [
                   {
                       title: 'English',
                       code: 'en'
                   },
                   {
                       title: 'Swedish',
                       code: 'sv'
                   }
               ]
           })
        });
    }
};
